<template>
	<div class="view" @click="$emit('close')">
		ANNOTATION
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: #000;
		color: white;
	}
</style>